import React, { useEffect, useState } from 'react';
import moment from "moment";

// reactstrap components
import {
    CardBody,
    Row,
    Col,
} from "reactstrap";


// services
import { showMessage } from "services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";

import { useAuth } from 'context/auth.js';
import AcompanhamentoLista from 'views/Acompanhamento/Lista';

export default function CancelamentoRequerimentos({ history }) {
    const { session, setLoading } = useAuth();

    const [visualizarTela, setVisualizarTela] = useState(false)

    const [requerimentos, setRequerimentos] = useState([])

    const formateDate = (date) => {
        return moment(date).format('DD/MM/YYYY');
    };

    const handleReturn = () => {
        setRequerimentos([]);
        loadRequerimentos();
    }

    const loadRequerimentos = () => {
        setLoading(true)
        api_GET('requerimento/GetCancelamentoRequerimentos')
            .then(result => {
                const requerimentosExclusao = result.data.map(requerimento => (
                    {...requerimento, excluirRequerimento: true}
                ))
                setRequerimentos(requerimentosExclusao)
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("AnaliseRequerimento.Visualizar", function (result) { setVisualizarTela(result) });
        loadRequerimentos()
    }, []);

    return (
        <>
            <div className="content">
                <CardBody>
                    <Row>
                        <Col md="12">
                            {(requerimentos.length > 0 && visualizarTela) &&
                                <AcompanhamentoLista
                                    requerimentos={requerimentos}
                                    handleReturn={handleReturn}
                                />}
                        </Col>
                    </Row>
                </CardBody>
            </div>
        </>
    );
}